/**
 * @store 门户 农技学堂 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryList(_, data) {
      return await api.post(`/api/article/medialists`, data);
    },
    async queryDetail(_, data) {
      return await api.post(`/api/article/mediaDetail`, data);
    },
    async queryRecommendLists(_, data) {
      return await api.post(`/api/article/mediaRecommendLists`, data);
    },
  },
}
